module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "couponCode"
  }, [(_vm.studentName != '' && _vm.rankNo != '') ? [_c('div', {
    staticClass: "couponCode-bg"
  }, [_c('div', {
    staticClass: "couponCode-container"
  }, [_c('div', {
    staticClass: "logoText"
  }), _vm._v(" "), _c('div', {
    staticClass: "enterCodeTip"
  }, [_c('p', [_vm._v("我是 "), _c('span', [_vm._v(" " + _vm._s(_vm.studentName) + "，")])]), _vm._v(" "), _c('p', [_vm._v("我在海渡月度赛中获得了")]), _vm._v(" "), _c('p', [_c('span', [_vm._v(" 第 " + _vm._s(_vm.rankNo) + " 名 ")]), _vm._v(" 的好成绩")])]), _vm._v(" "), _c('img', {
    staticClass: "barCodeText",
    attrs: {
      "src": require("assets/images/share/image_text.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "barCode",
    attrs: {
      "src": _vm.obj.url,
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "couponCode-left circlePart"
  }), _vm._v(" "), _c('p', {
    staticClass: "couponCode-right circlePart"
  }), _vm._v(" "), _c('p', {
    staticClass: "dashedLine"
  })])])] : [_c('h1', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "50%"
    }
  }, [_vm._v("您的链接缺少分享信息,请确认后重试")])]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "downloadApp"
  }, [_c('p', [_vm._v("长按二维码，下载"), _c('span', [_vm._v(" 海渡职校 ")]), _vm._v("APP")]), _vm._v(" "), _c('p', [_vm._v("一起参加海渡月度赛")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fcf604a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShareMonthlyCompetition.vue
// module id = 323
// module chunks = 1